export default __webpack_public_path__ + "static/media/Icon-close-circle-outline.acb3c1d5.svg";